import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// Bootstrap CSS and JS
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import 'bootstrap-icons/font/bootstrap-icons.css'

// Global CSS
import './styles/global.css'

// Firebase initialization
import './firebase/config'
import { useFirebaseAuth } from './composables/useFirebaseAuth'

const app = createApp(App)

// Initialize Firebase Auth listener
const { initAuth, cleanup } = useFirebaseAuth()
initAuth()

// Cleanup on app unmount
window.addEventListener('beforeunload', cleanup)

// Use router
app.use(router)

// Import utilities
import { formatDate, validateEmail } from './utils/helpers'

// Global properties
app.config.globalProperties.$formatDate = formatDate
app.config.globalProperties.$validateEmail = validateEmail

app.mount('#app')
